import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import { isGroupedTask } from '../../tasks/tasks.model';

/** Every task id in a list, flattening groups down to their subtasks. */
export const getTaskIds = (tasks: (MinifiedTask | GroupedTask)[]): string[] =>
  tasks.flatMap((task) => (isGroupedTask(task) ? task.tasks.map((subtask) => subtask.id) : [task.id]));
